import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { ExpenseGroup } from '@api/CashFlows/CashFlow';
import { getExpenseGroupName } from '@api/ExpenseCategories/ExpenseCategory';

/**
 * Un color por grupo (plan de Gastos §5.4): el mismo en el POS, la lista de gastos
 * y el Estado de Resultados. Un solo mapa: si un grupo cambia de color, cambia en
 * todos lados.
 */
export const EXPENSE_GROUP_COLORS: Record<ExpenseGroup, string> = {
    [ExpenseGroup.Supplies]: '#2E7D32',
    [ExpenseGroup.Payroll]: '#1565C0',
    [ExpenseGroup.Fixed]: '#6A1B9A',
    [ExpenseGroup.Variable]: '#00838F',
    [ExpenseGroup.Maintenance]: '#EF6C00',
    [ExpenseGroup.Operating]: '#AD1457',
    [ExpenseGroup.OutsideStatement]: '#616161'
};

/** Lo capturado antes de F2. */
export const UNCATEGORIZED_COLOR = '#9E9E9E';

interface ExpenseGroupChipProps extends Omit<ChipProps, 'label' | 'color'> {
    group?: ExpenseGroup;
    /** Por defecto, el nombre del grupo. */
    label?: string;
}

const ExpenseGroupChip: React.FunctionComponent<ExpenseGroupChipProps> = ({ group, label, sx, ...rest }) => (
    <Chip
        size="small"
        label={label || getExpenseGroupName(group)}
        sx={{ color: '#FFFFFF', bgcolor: group ? EXPENSE_GROUP_COLORS[group] : UNCATEGORIZED_COLOR, maxWidth: '100%', ...sx }}
        {...rest}
    />
);

export default ExpenseGroupChip;
